/**
 * Onde a fila mora.
 *
 * O caminho fica aqui, e não dentro do componente, porque três lugares
 * precisam dele: a fábrica de rotas, o cartão do painel inicial e — quando
 * quem cuida de `app/nav.ts` quiser — o item da navegação principal. Três
 * literais iguais espalhados é como um deles fica para trás e vira 404.
 *
 * ## Por que não é uma aba de `/administracao`
 *
 * Administração são **catálogos de vocabulário**, abertos por quem configura o
 * sistema, talvez uma vez por mês. Uma mensagem retida é um cliente esperando
 * resposta agora. Enfiar a fila lá dentro é a mesma decisão que produziu o
 * problema original: o registro existe, ninguém passa perto.
 */

export const CAMINHO_DAS_RETIDAS = '/mensagens-retidas';

export const ROTULO_DAS_RETIDAS = 'Mensagens retidas';

export const RESUMO_DAS_RETIDAS =
  'E-mails que chegaram à caixa do service desk e não viraram chamado — quase ' +
  'sempre porque o remetente não pertence a nenhuma organização cadastrada. ' +
  'Cada um espera uma decisão, e cada um diz o motivo dele.';
